import GenericNotificationDisplay from './GenericNotificationDisplay'
import {NotificationDTO} from '../../../../generated/api'

const GuildCreationNotification = ({notification}: {notification: NotificationDTO}) => (
    <GenericNotificationDisplay notification={notification} title="User removed from Guild" canClose={true} />
)

export default GuildCreationNotification